function SuspenseContent(){
    return(
        <div className="w-full h-screen text-gray-300 bg-base-100">
            Loading...
        </div>
    )
}

export default SuspenseContent